import {
  EditingState,
  PagingState,
  RowDetailState,
  SortingState,
} from '@devexpress/dx-react-grid';
import {
  DragDropProvider,
  Grid,
  Table,
  TableColumnVisibility,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { createStyles, makeStyles, Paper, Box, IconButton } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { ToolDisposalCellComponent } from './newRequestCellComponent';
import { ToolDisposalNoDataCell } from './newRequestNoDataCell';
import { ToolDisposalSortLabel } from './newRequestSortLabel';
import { ToolDisposalTableComponent } from './newRequestTableComponent';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit'; // Import Edit icon
import { AddToolModel } from './newRequestAddToolModel'; // NEW IMPORT
import { useAppData } from '../../services/hooks';
import { useDispatch } from "react-redux";
import {
  submitDataAction,
} from '../toolDisposalSlice';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment'; // BEGIN: Add moment import

export type ColumnType = {
  name: string;
  title: string;
  wordWrapEnabled?: boolean;
  renderCell?: any
};

export type TableColumnExtensions = {
  columnName: string;
  wordWrapEnabled: boolean;
  width?: number | string;
};

export const scrollToTop = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};



export const NewRequestToolsGrid: FC<any> = ({ SupplierData }) => {
  const classes = useStyles();
  const [modifyTools, setModifyTools] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  console.log("isModalOpen", isModalOpen);
  const row = useAppData((r) => r.toolDisposalSlice.updateValues.value);
  console.log("rowData", row);
  const toolsDetailFromStore = useAppData(
    (r) => r.toolDisposalSlice.updateValues.value.toolsDetails?.toolsDetail
  );

  const toolsDetailRows: any[] = Array.isArray(toolsDetailFromStore)
    ? toolsDetailFromStore
    : Array.isArray(row?.toolsDetails?.toolsDetail)
      ? row.toolsDetails.toolsDetail
      : [];
  useEffect(() => {
    if (modifyTools || toolsDetailRows.length === 0) return;
    handleToolDetails(toolsDetailRows.map((data: any) => ({ ...data, id: data.id ?? Date.now().toString() + Math.random().toString(36).substr(2, 9) })));
    setModifyTools(true);
  }, [toolsDetailRows, modifyTools]);
  console.log("toolData", toolsDetailRows);
  const [disabled, setdisabled] = React.useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    toolsDetailRows.length >= 20 || row.disposalStatusId === "2" ||
      row.disposalStatusId === "3" ||
      row.disposalStatusId === "4" ? setdisabled(true) : setdisabled(false);

  }, [toolsDetailRows]);
  let gridRow = toolsDetailRows;
  console.log("gridRow", gridRow);
  const gridRowUpdated = Array.isArray(gridRow)
    ? gridRow.map((data: any) => ({
      ...data,
      lastUsedDate: moment(data.lastUsedDate).format("YYYY-MM-DD"),
      modelYearMinMax: `${data.modelYearMin ?? ''} - ${data.modelYearMax ?? ''}`.trim() || '',
      CountryNameAndCode:`${data.countryToolResidesInName ?? ''} (${data.countryToolResidesIn ?? ''})`.trim() || '',
      StateNameAndCode:`${data.stateToolResidesInName ?? ''} (${data.stateToolResidesIn ?? ''})`.trim() || '',
      icon: (
        <IconButton
          disabled={row.disposalStatusId === "2" ||
            row.disposalStatusId === "3" ||
            row.disposalStatusId === "4" ? true : false}
          color={
            row &&
              (row.disposalStatusId === "2" ||
                row.disposalStatusId === "3" ||
                row.disposalStatusId === "4")
              ? "secondary"
              : "primary"
          }
          onClick={() =>
            row &&
              (row.disposalStatusId === "2" ||
                row.disposalStatusId === "3" ||
                row.disposalStatusId === "4")
              ? console.log("")
              : deleteToolListing(data)
          }
        >
          <DeleteForeverIcon />
        </IconButton>
      ),
      editIcon: (
        <IconButton
          disabled={row.disposalStatusId === "2" ||
            row.disposalStatusId === "3" ||
            row.disposalStatusId === "4" ? true : false}
          color="primary"
          onClick={() => {
            const { ...rowdata } = row;
            let body = rowdata;
            body.id = data.id;
            body.supplierName = data.supplierName;
            body.supplierNumber = data.supplierNumber;
            body.poNumber = data.poNumber;
            body.productLines = data.productLines;
            body.countryToolResidesIn = data.countryToolResidesIn;
            body.stateToolResidesIn = data.stateToolResidesIn;
            body.toolTypeId = data.toolTypeId;
            body.toolType = data.toolType;
            body.totalPOValue = data.totalPOValue;
            body.projectNumber = data.projectNumber;
            body.toolNumber = data.toolNumber;
            body.toolDescription = data.toolDescription;
            body.modelYearMin = data.modelYearMin;
            body.modelYearMax = data.modelYearMax;
            body.lastUsedDate =
            data.lastUsedDate ? moment(data.lastUsedDate).format("YYYY-MM-DD")
                : undefined;

            dispatch(
              submitDataAction({
                body,
              })
            );
            setIsModalOpen(true);
          }}
        >
          <EditIcon />
        </IconButton>
      ),
    }))
    : [];
  const deleteToolListing = (e: { id: string }) => { // Specify the type for 'e'
    let data = gridRow.filter(i => i.id !== e.id); // Changed from toolNumber to id
    handleToolDetails(data);
  }

  const createTagHandler = (tagType: 'toolsDetails') => (value: any) => {
    const { ...rowdata } = row;

    const toolsDetailValue = Array.isArray(value)
      ? value.map((data: any) => ({
        id: data.id,
        supplierName: data.supplierName,
        supplierNumber: data.supplierNumber,
        poNumber: data.poNumber,
        productLines: data.productLines,
        countryToolResidesIn: data.countryToolResidesIn,
        stateToolResidesIn: data.stateToolResidesIn,
        countryToolResidesInName: data.countryToolResidesInName,
        stateToolResidesInName: data.stateToolResidesInName,
        toolTypeId: data.toolTypeId,
        toolType: data.toolType,
        totalPOValue: data.totalPOValue,
        projectNumber: data.projectNumber,
        toolNumber: data.toolNumber,
        toolDescription: data.toolDescription,
        modelYearMin: data.modelYearMin,
        modelYearMax: data.modelYearMax,
        lastUsedDate:
          data.lastUsedDate ? moment(data.lastUsedDate).toISOString()
            : undefined
      }))
      : [];

    dispatch(
      submitDataAction({
        body: {
          ...rowdata,
          [tagType]: {
            toolsDetail: toolsDetailValue,

          },
        },
      })
    );
  };

  const handleToolDetails = createTagHandler('toolsDetails');

  type Tool = {
    id?: string | number;
    toolNumber: string;
    [key: string]: any;
  };

  const onConfirmClick = () => {
    const rows: Tool[] = Array.isArray(toolsDetailRows) ? [...toolsDetailRows] : [];

    const toolNumber = row.toolNumber?.trim();


    const rowIndex = rows.findIndex(r => r?.id === row.id);
    const newRow = {
      ...row,
      toolNumber: toolNumber ?? 'No tool number',
      lastUsedDate: row.lastUsedDate ? moment(row.lastUsedDate).format("YYYY-MM-DD") : undefined,
      id: row.id ?? Date.now().toString() + Math.random().toString(36).slice(2, 11), // Changed from substr to slice
    };

    if (rowIndex > -1) {
      // Update existing row
      rows[rowIndex] = newRow;
    } else {
      // Add new row
      rows.push(newRow);
    }
    handleToolDetails(rows);
  };



  const columns: ColumnType[] = [
    { name: 'id', title: 'ID' },
    { name: 'toolNumber', title: 'tool number-description ', wordWrapEnabled: true },
    { name: 'toolType', title: 'tool Type', wordWrapEnabled: true },
    { name: 'supplierName', title: 'Supplier Name', wordWrapEnabled: true },
    { name: 'poNumber', title: 'Original PO Number', wordWrapEnabled: true },
    { name: 'totalPOValue', title: 'Total Tool Value', wordWrapEnabled: true },
    { name: 'productLines', title: 'product Lines', wordWrapEnabled: true },
    { name: 'projectNumber', title: 'project Number', wordWrapEnabled: true },
    { name: 'modelYearMinMax', title: 'model Year Min - Max', wordWrapEnabled: true },
    { name: 'lastUsedDate', title: 'last Date Used', wordWrapEnabled: true },
    { name: 'CountryNameAndCode', title: 'country Tool Resides', wordWrapEnabled: true },
    { name: 'StateNameAndCode', title: 'state Tool Resides', wordWrapEnabled: true },

    { name: 'editIcon', title: 'Edit' },
    { name: "icon", title: "Remove" }
  ];
  const tableColumnExtensions: TableColumnExtensions[] = [

    {
      columnName: 'toolNumber',
      wordWrapEnabled: true,
    },
    {
      columnName: 'toolType',
      wordWrapEnabled: true,
    },

    {
      columnName: 'supplierName',
      wordWrapEnabled: true,
    },
    {
      columnName: 'poNumber',
      wordWrapEnabled: true,
    },
    {
      columnName: 'totalPOValue',
      wordWrapEnabled: true,
    },
    {
      columnName: 'productLines',
      wordWrapEnabled: true,
    },
    {
      columnName: 'projectNumber',
      wordWrapEnabled: true,
    },
    {
      columnName: 'modelYearMin',
      wordWrapEnabled: true,
    },
    {
      columnName: 'modelYearMax',
      wordWrapEnabled: true,
    },
    {
      columnName: 'lastUsedDate',
      wordWrapEnabled: true,
    },
    {
      columnName: 'countryToolResidesIn',
      wordWrapEnabled: true,
    },
    {
      columnName: 'stateToolResidesIn',
      wordWrapEnabled: true,
    },

  ];



  const handlePageIndexChange = (pageIndex: number) => {

    scrollToTop();
  };
  const handlePageSizeChange = (pageSize: number) => {

    scrollToTop();
  };

  return (
    <Paper className={classes.requestContainer}>
      <Box className={classes.gridContainer}>
        <Grid rows={gridRowUpdated} columns={columns}  >
          <EditingState onCommitChanges={() => console.log("clicked")} />

          <PagingState
            currentPage={1}
            onCurrentPageChange={handlePageIndexChange}

            onPageSizeChange={handlePageSizeChange}
          />
          <SortingState

          />
          <DragDropProvider />
          <RowDetailState

          />
          <Table
            tableComponent={ToolDisposalTableComponent}
            columnExtensions={tableColumnExtensions}
            noDataCellComponent={ToolDisposalNoDataCell}
            cellComponent={ToolDisposalCellComponent}
          />
          <TableHeaderRow showSortingControls sortLabelComponent={ToolDisposalSortLabel} />
          <TableColumnVisibility defaultHiddenColumnNames={['id']} />
        </Grid>

      </Box>
      <Box>
        <AddToolModel
          paramsData={row}
          requester={row && row.requester}
          onConfirmClick={onConfirmClick}
          disabled={disabled}
          openModal={isModalOpen}
          onaHandleClose={() => setIsModalOpen(false)}
        />

      </Box>
      <ToastContainer />
    </Paper>
  );
};


const useStyles = makeStyles(() =>
  createStyles({
    requestContainer: {
      '& .MuiTable-root': {
        minWidth: 'inherit !important',
      },
    },
    gridContainer: {
      //height: "400px",
      //overflow: "hidden",
      //overflowY: "scroll",
      minWidth: '1900px',

    },
    button: {
      width: "100%",
      justifyContent: "left",
      background: "#EBF1F7",
      color: "black",
      border: 0,
      borderRadius: 0,
      boxShadow: "none",
      '&:hover': {
        backgroundColor: '#ffffff',
        color: "#004e97",
        boxShadow: 'none',
      },
    },
    groupCell: {
      '& > div': {
        backgroundColor: 'inherit',
      },
    },
  }),
);



function setWarningMessage(message: string) {
  if (message) { // Check if message is not empty
    toast.warn(message, {
      position: toast.POSITION.TOP_CENTER, // Set position for better visibility
      autoClose: 5000, // Auto close after 5 seconds
      hideProgressBar: false, // Show progress bar
      closeOnClick: true, // Allow closing on click
      pauseOnHover: true, // Pause on hover
      draggable: true, // Allow dragging
      progress: undefined, // Default progress
    });
  }
}

